import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-speedometer-loader',
  templateUrl: './speedometer-loader.component.html',
  styleUrls: ['./speedometer-loader.component.scss']
})
export class SpeedometerLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
